<aside class="copy-move-action" [ngClass]="copyMoveSwapGridClass(formGroup.controls['type'].value)">
  <h4 class="to" [ngSwitch]="formGroup.controls['type'].value">
    <span *ngSwitchCase="'SWAP'">with</span>
    <span *ngSwitchDefault>to</span>
  </h4>
  <div>
    <app-paired-autocomplete
      #actionDestinationCopyMoveSwap
      [selectedFieldControl]="destinationControl"
      [secondaryEntityControl]="destinationDescriptorControl"
      [primaryEntity]="primaryEntity"
      [componentId]="'action-fieldValue-destination'"
      [entitiesOptions]="entitiesOptions"
      [inputRequired]="true"
      [dataSourceType]="dataSourceType"
      [placeholder]='copySwapMovePlaceholder'
      [overlayPositioningConfig]="overlayPositioningConfig">
    </app-paired-autocomplete>
  </div>
  <span *ngIf="errorMessage" class="material-icons notranslate tooltip-icon danger" matTooltip="{{errorMessage}}"
        matTooltipClass="mat-tooltip">error_outline</span>
  <span *ngIf="infoMessage" class="material-icons notranslate tooltip-icon info" matTooltip="{{infoMessage}}"
        matTooltipClass="mat-tooltip">help_outline</span>
</aside>
